<template>
  <section
    class="emd-menu__section menu-section"
    :class="{
      _active: active,
      _open: opened
    }"
    :data-onboarding="item.routeName === 'settings' ? item.routeName : null"
  >
    <a
      class="menu-link"
      @click="setOpenSection"
    >
      <span
        data-testid="dropdown-menu"
        class="emd-menu__label menu-item"
        >{{ $t(item.label) }}</span
      >
      <span
        v-if="item.new"
        class="emd-tag _color_info eu-ml_2 eu-display_none eu-display_inline_md"
        >{{ $t('sidemenu.new') }}</span
      >
      <div
        v-if="item.items"
        class="emd-menu__arrow menu-icon"
      >
        <i class="uil uil-angle-right"></i>
      </div>
      <span
        v-if="item.beta"
        class="emd-tag _color_info eu-ml_2 eu-display_none eu-display_inline_md"
        >{{ $t('sidemenu.beta') }}</span
      >
    </a>

    <slot />
  </section>
</template>

<script>
import Amplitude from '@/amplitude-events/sidemenu.amplitude'

export default {
  name: 'AppMenuItem',

  props: {
    item: {
      type: Object,
      required: true
    },
    routeName: String
  },

  data () {
    return {
      openSection: 'home'
    }
  },

  computed: {
    hasSubmenu () {
      const { items } = this.item
      return items && Object.values(items).length > 0
    },
    active () {
      const menuItem =
        this.$route?.meta?.breadcrumb ?? this.$route?.meta?.navigationBar
      if (!menuItem) return false

      const root = menuItem?.refer || menuItem.current || menuItem.label

      const position = root.search(this.item.key)

      return position >= 0
    },
    opened () {
      if (this.hasSubmenu) {
        return (
          Object.values(this.item.items)?.find(el => el.active) ||
          this.isSectionEqualsItemClicked()
        )
      }

      return this.isSectionEqualsItemClicked()
    }
  },

  methods: {
    isSectionEqualsItemClicked () {
      return this.openSection === this.item.key
    },
    setOpenSection () {
      const { key } = this.item

      if (this.openSection === key) {
        this.openSection = ''
      } else {
        this.openSection = key
      }

      if (!this.hasSubmenu) {
        if (Amplitude.events[key]) {
          Amplitude.events[key].buttonClicked()
        }

        this.$router.push({ name: key }).catch(err => err)
      }
    }
  }
}
</script>

<style scoped>
@import './app-menu.css';

@media only screen and (max-width: 768px) {
  .menu-section {
    width: 100%;
  }
  .menu-section._open .menu-icon {
    transform: rotate(90deg);
  }

  .menu-section._active .menu-item {
    color: var(--color-green);
  }
}
</style>

<i18n>
  {
    "pt-BR": {
      "sidemenu": {
        "new": "Novo",
        "beta": "Beta",
        "home": "Resumo",
        "sales": "Vendas",
        "financial": "Financeiro",
        "recurrence": "Recorrência",
        "recipients": "Recebedores",
        "customers": "Clientes",
        "webhooks": "Webhooks",
        "team": "Equipe",
        "settings": "Configurações",
        "physical-world": "Loja Física"
      }
    },
    "en-US": {
      "sidemenu": {
        "new": "New",
        "beta": "Beta",
        "home": "Resume",
        "sales": "Sales",
        "financial": "Financial",
        "recurrence": "Recurrence",
        "recipients": "Recipients",
        "customers": "Customers",
        "webhooks": "Webhooks",
        "team": "Team",
        "settings": "Settings",
        "physical-world": "Physical World"
      }
    }
  }
</i18n>
